module.exports = __webpack_public_path__ + "static/media/Template_62.7dabe44b.png";